import { erpAxios } from '..';

const addSuduznik = async (data) => {
  const res = await erpAxios.post(`/suduznici/add`, data);
  return res;
};

export default addSuduznik;
